import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/shape-9.png'


const _hoisted_1 = { class: "container mw-1356" }
const _hoisted_2 = {
  class: "services-test-content",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_3 = { class: "top-title" }
const _hoisted_4 = { class: "text-white" }
const _hoisted_5 = { class: "text-silver" }
const _hoisted_6 = { class: "d-flex align-items-center amount" }
const _hoisted_7 = { class: "flex-grow-1 ms-3" }
const _hoisted_8 = {
  key: 0,
  class: "trial-success"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "border-style" }
const _hoisted_13 = {
  key: 2,
  class: "trial-error"
}
const _hoisted_14 = { class: "d-flex gap-2 flex-wrap mt-3" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "border-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "services-test-area bg-mg ptb-100 position-relative overflow-hidden",
    style: _normalizeStyle({ backgroundImage: 'url(' + (_ctx.c.background_image_url || _ctx.bgImage) + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.c.top_title), 1),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.c.title), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.c.subtitle), 1),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("i", { class: "flaticon-tv" })
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", null, [
              _createTextVNode("$" + _toDisplayString(_ctx.c.price), 1),
              _createElementVNode("sub", null, "/ " + _toDisplayString(_ctx.c.period), 1)
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.c.period_label), 1)
          ])
        ]),
        (_ctx.trialSent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.trialMessage), 1)
            ]))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              class: "trial-form",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitTrial && _ctx.submitTrial(...args)), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trialName) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Your name",
                disabled: _ctx.trialLoading
              }, null, 8, _hoisted_9), [
                [_vModelText, _ctx.trialName]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trialEmail) = $event)),
                type: "email",
                class: "form-control",
                placeholder: "Your email",
                required: "",
                disabled: _ctx.trialLoading
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.trialEmail]
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn bg-grey-teal",
                disabled: _ctx.trialLoading
              }, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.trialLoading ? 'Sending...' : (_ctx.c.cta_text || 'Start Free Trial')), 1)
              ], 8, _hoisted_11)
            ], 32)),
        (_ctx.trialError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.trialError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            href: 'tel:' + _ctx.c.phone,
            class: "btn bg-transparent"
          }, [
            _createElementVNode("span", _hoisted_16, [
              _createElementVNode("span", null, "Call: " + _toDisplayString(_ctx.c.phone), 1),
              _cache[5] || (_cache[5] = _createTextVNode(" for any enquiry"))
            ])
          ], 8, _hoisted_15)
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape shape-9",
      alt: "shape"
    }, null, -1))
  ], 4))
}